import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppInfo, UserProfile } from '../models';
import { AppConfig } from '../models/app-config.model';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';
import { ODataParams, ODataResponse } from '@tdw/core';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  url: string;
  version: string;

  constructor(private http: HttpClient, @Inject(ENV_CONFIG) private config: EnvironmentConfig) {
    this.url = this.config.endpoints.baseApi.url;
    this.version = this.config.endpoints.baseApi.version;
  }

  getProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.url}api/${this.version}/UserProfile`);
  }

  getAppInfo(): Observable<AppInfo> {
    return this.http.get<AppInfo>(`${this.url}api/${this.version}/AppInfo`)
  }

  getAppConfig(q: ODataParams): Observable<AppConfig[]> {
    return this.http.get<ODataResponse<AppConfig[]>>(`${this.url}odata/${this.version}/AppConfigs${q.toQuery()}`).pipe(map(res => res.value || []));
  }
}
